/**
 * Transforms a payment plan API model to a view entity
 *
 * @param {import('../types/PaymentPlan.api').IPaymentPlanApiModel} model - API model
 * @returns {import('../types/PaymentPlan').IPaymentPlanViewEntity} View entity
 */
const toPaymentPlanViewEntity = (model) => ({
  id: model.id,
  name: model.name,
  description: model.description,
  basePrice: model.basePrice,
  finalPrice: model.finalPrice,
  nextBillingDate: model.nextBillingDate,
  features: model.features,
  createdAt: model.createdAt,
  updatedAt: model.updatedAt,
  billingInterval: model.billingInterval,
  intervalCount: model.intervalCount,
});

/**
 * Transforms API response to payment plans result
 *
 * @param {import('../types/PaymentPlan.api').IGetPaymentPlansApiResponse} response - API response
 * @returns {import('../types/PaymentPlan').IGetPaymentPlansResult} Payment plans result
 */
const toGetPaymentPlansResult = (response) => ({
  data: response.data.map(toPaymentPlanViewEntity),
});

/**
 * Payment Plan Adapters
 * Provides transformation functions between API models and view entities
 */
export const PaymentPlanAdapters = {
  toPaymentPlanViewEntity,
  toGetPaymentPlansResult,
};
